/**
 * Created by esenckewitch on 24.06.2026
 *
 * https://docs.crazygames.com/sdk/in-game-purchases/
 */

const CrazyXsollaPayments = function () {
    XsollaPayments.call(this);
};

CrazyXsollaPayments.prototype = Object.create(XsollaPayments.prototype);
CrazyXsollaPayments.prototype.constructor = CrazyXsollaPayments;

CrazyXsollaPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.CRAZY);
};

CrazyXsollaPayments.prototype.getAuthToken = function (callback) {
    CrazyGames.SDK.user.getXsollaUserToken()
        .then((token) => {
            callback(connector.CODE_SUCCEED, {
                token,
                project: connector.config.crazy.appId
            });
        })
        .catch((error) => {
            console.log("CrazyGames getXsollaUserToken error:", error);
            callback(connector.CODE_CANCELLED, undefined, { error: "auth", message: error && error.message });
            this.bus.trigger("stream:logs", "xsolla_init_widget_failed");
        });
};
